import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    Input,
    OnInit,
    Output,
    ViewEncapsulation,
} from '@angular/core';
import { INameIdObj } from '@fi-shared/fi-shared-interfaces';
import { FiChecklist2ReportType } from '@fi-shared/checklist/fi-checklist2-report/enums/fi-checklist2-report-type';
import { FiChecklist2ReportHelperService } from '@fi-shared/checklist/fi-checklist2-report/services/fi-checklist2-report-helper.service';
interface IAvailableChecklistReportWidgetOptions extends INameIdObj {
    IconClassName: string;
}

// todo: remove this component and use fi-report-widget-new-widget-type-select-step component

@Component({
    selector: 'fi-checklist2-report-new-widget-type-select-step',
    templateUrl: './new-widget-type-select.component.html',
    styleUrls: ['new-widget-type-select.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-checklist2-report-new-widget-type-select-step' },
    standalone: false,
})
export class FiChecklist2ReportNewWidgetTypeSelectStepComponent implements OnInit {
    @Input({ required: true }) auditMode: boolean;
    @Output() onSetCurrentReportWidgetType = new EventEmitter<FiChecklist2ReportType>();

    availableChecklistReportWidgetsData: IAvailableChecklistReportWidgetOptions[] = [];

    constructor(private fiChecklist2ReportHelperService: FiChecklist2ReportHelperService) {}

    ngOnInit(): void {
        if (
            this.fiChecklist2ReportHelperService.isReportTypeAvailable(
                FiChecklist2ReportType.OpenChecklists,
                this.auditMode,
            )
        ) {
            this.availableChecklistReportWidgetsData.push({
                Id: FiChecklist2ReportType.OpenChecklists,
                Name: 'checklist.report_open_checklists',
                IconClassName: 'far fa-ballot-check',
            });
        }
        if (
            this.fiChecklist2ReportHelperService.isReportTypeAvailable(
                FiChecklist2ReportType.AttentionRequired,
                this.auditMode,
            )
        ) {
            this.availableChecklistReportWidgetsData.push({
                Id: FiChecklist2ReportType.AttentionRequired,
                Name: 'checklist.report_attention_required',
                IconClassName: 'far fa-circle-exclamation',
            });
        }
        if (
            this.fiChecklist2ReportHelperService.isReportTypeAvailable(
                FiChecklist2ReportType.PastChecklists,
                this.auditMode,
            )
        ) {
            this.availableChecklistReportWidgetsData.push({
                Id: FiChecklist2ReportType.PastChecklists,
                Name: 'checklist.checklist_history',
                IconClassName: 'far fa-clock-rotate-left',
            });
        }
    }

    setCurrentReportWidgetType(reportType: FiChecklist2ReportType) {
        this.onSetCurrentReportWidgetType.emit(reportType);
    }
}
